@if (showSidebar) {
  <app-sidebar />
}
<main class="wrapper">
  <div class="container-fluid">
    <router-outlet />
  </div>
</main>
